import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GlButton from '@/components/gl-button';
import Vue from 'vue';
import CommonHeader from './header';
Vue.component('GlButton', GlButton);
export default {
  components: {
    CommonHeader: CommonHeader
  },
  computed: {
    img: function img() {
      if (['/register/index', '/register/team', '/login/create-company'].includes(this.$route.path)) {
        return require('@/assets/img/img_register.png');
      }
      if (['/login/index', '/login/loginCompany', '/login/loginWarning'].includes(this.$route.path)) {
        return require('@/assets/img/img_login.png');
      }
      return require('@/assets/img/advert.png');
    }
  }
};